<template>
  <FullscreenFrontageDialog ref="upgradeDialog">
    <template slot-scope="dialogProps">
      <UpgradePopUp :upgradeName="dialogProps.upgradeName"
                    @onCancelClicked="handleClose"
                    @onOkClicked="handleSubmit" />
    </template>
  </FullscreenFrontageDialog>
</template>

<script>
  import UpgradePopUp from "./UpgradePopUp";
  import { FullscreenFrontageDialog } from "@/modules/common/components"

  export default {
    name: "UpgradePopUpPage",
    components: { UpgradePopUp, FullscreenFrontageDialog },
    methods: {
      handleClose() {
        this.$refs.upgradeDialog.handleClose()
      },
      handleSubmit() {
        this.$refs.upgradeDialog.handleSubmit()
      }
    }
  };
</script>
